import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import classNames from 'classnames';

import { Tab as TabProps } from 'entities/Tab/interfaces';

import styles from './Tab.module.scss';

const Tab: React.FC<TabProps> = ({ href, title }) => (
  <LinkContainer
    exact
    to={href}
    className={classNames('border border-bottom-0 border-white rounded-top ml-2 nav-item', styles.tab)}
    activeClassName={styles.activeTab}
  >
    <Nav.Link className="d-flex justify-content-center align-items-center">
      <span className="text-center">{title}</span>
    </Nav.Link>
  </LinkContainer>
);

export default Tab;
